<script>
	export let id = '';
	export let value = '#000';
	import { onMount } from 'svelte';
	let mounted = false;
	onMount(() => {
		mounted = true;
	});
</script>

<svelte:head>
	<!-- for testting -->
	<!-- <link rel="stylesheet" href="https://hub.shopbox.ai/coloris/coloris.css" />
	<script src="https://hub.shopbox.ai/coloris/coloris.js"></script> -->
	{#if mounted}
		<script>
			Coloris({
				el: '.coloris',
				format: 'mixed',
				clearButton: true,
				clearLabel: 'Clear',
				closeButton: true,
				closeLabel: 'Close'
			});
		</script>
	{/if}
</svelte:head>

<div class="color-picker">
	<input {id} type="text" placeholder="#000" class="coloris" bind:value data-coloris />
</div>

<style>
	:global(#clr-clear) {
		background-color: transparent;
		color: #091eb5;
	}
	:global(#clr-close) {
		border-radius: 0;
		background-color: #f64740;
	}
	:global(.clr-field) {
		width: 100%;
	}
	:global(.clr-field button) {
		width: 22px;
		height: 22px;
		left: 5px;
		top: 20px;
		right: auto;
		border-radius: 5px;
	}
	input {
		width: 100%;
		padding: 12px 6px;
		padding-left: 30px;
		margin: 0.5em 0;
		border: 1px solid #727178;
		border-radius: 3px;
	}
</style>
